(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf26-behavior"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(e){const b=e.target.closest('.s26-arrow');if(b){const track=b.closest('[data-s26-carousel]').querySelector('.s26-track');track.scrollBy({left:(b.classList.contains('s26-prev')?-1:1)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}});
document.addEventListener('play',function(e){if(e.target.tagName==='VIDEO'&&e.target.closest('.s26')){document.querySelectorAll('.s26 video').forEach(v=>{if(v!==e.target)v.pause()});}},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf26-halloween-timer"] && !Shopify.designMode) return;
  try {
    function updateSculptedCountdown() {
  document.querySelectorAll('[data-sf-campaign]').forEach(banner => {
    const remaining = Math.max(0, Math.floor((Date.parse(banner.dataset.end) - Date.now()) / 1000));
    if (!remaining) { banner.hidden = true; return; }
    const values = {days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
    for (const [key,value] of Object.entries(values)) { const node=banner.querySelector('[data-sf-'+key+']'); if(node)node.textContent=String(value).padStart(2,'0'); }
  });
}
updateSculptedCountdown();
setInterval(updateSculptedCountdown,1000);
document.addEventListener('shopify:section:load',updateSculptedCountdown);
  } catch(e) { console.error(e); }
})();

})();
